import { render, staticRenderFns } from "./ProducerDetails.vue?vue&type=template&id=3b2e9a70&scoped=true&"
import script from "./ProducerDetails.vue?vue&type=script&lang=js&"
export * from "./ProducerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProducerDetails.vue?vue&type=style&index=0&id=3b2e9a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e9a70",
  null
  
)

export default component.exports